// HomePage.jsx
// language: JavaScript (React)
// purpose: Homepage for Lu - Fit Personal Trainer SPA

// import "../styles/HomePage.css";
import AboutSection from "../components/AboutSection";
import ServiceList from "../components/ServiceList";
import HeroSection from "../components/HeroSection";
import ContactSection from "../components/ContactSection";
import Testimonials from "../components/Testimonials";
import Rates from "../components/Rates";
import InformationSection from "../components/InformationSection";
import SocialMedia from "../components/SocialMedia";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet";

function HomePage() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.hash) {
      const section = document.querySelector(location.hash);
      if (section) {
        setTimeout(() => {
          section.scrollIntoView({ behavior: "smooth" });
          navigate(location.pathname, { replace: true });
        }, 300); // Allow DOM to load
      }
    }
  }, [location, navigate]);

  return (
    <>
      <Helmet>
        <title>Lu - Fit | Personal Trainer in Cape Town | Fitness & Online Coaching</title>
        <meta
          name="description"
          content="Achieve your best self with Lu - Fit — personal training, fitness coaching, and wellness programs in Cape Town. Book your free consultation today!"
        />
        <meta
          name="keywords"
          content="personal trainer Cape Town, fitness coach, strength training, online coaching, gym programs, Lu Fit, Cape Town wellness, weight loss coach, workout plan"
        />
        <meta name="author" content="Lu - Fit Personal Training" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://basic-tier-personal-trainer.vercel.app/" />

        {/* Open Graph for social sharing */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://basic-tier-personal-trainer.vercel.app/" />
        <meta property="og:title" content="Lu - Fit | Personal Training & Wellness in Cape Town" />
        <meta
          property="og:description"
          content="Join Lu - Fit for personalized training and coaching. Fitness made simple and effective in Cape Town, Western Cape."
        />
        <meta
          property="og:image"
          content="https://basic-tier-personal-trainer.vercel.app/og-preview.jpg"
        />

        {/* Twitter card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://basic-tier-personal-trainer.vercel.app/" />
        <meta name="twitter:title" content="Lu - Fit | Personal Trainer in Cape Town" />
        <meta
          name="twitter:description"
          content="Transform your body and mindset with Lu - Fit personal training programs tailored to your goals."
        />
        <meta
          name="twitter:image"
          content="https://basic-tier-personal-trainer.vercel.app/og-preview.jpg"
        />
      </Helmet>

      <div className="home-page-container">
        <HeroSection id="hero-section" />
        <ServiceList id="services" />
        <AboutSection id="about-us" />
        <Rates id="rates" />
        <Testimonials id="testimonials" />
        <InformationSection />
        <ContactSection id="contact" />
        <SocialMedia />
      </div>
    </>
  );
}

export default HomePage;
